/* eslint-disable ordered-imports/ordered-imports */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { CartLineModel, OrderLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { CoveoProductContextModel } from "@NA/Components/Coveo/Contexts/CoveoProductContext";
// import { sendClickEvent } from "@NA/Services/ADICoveoService";

interface OwnProps {
    product: CoveoProductContextModel;
    extendedStyles?: ProductDescriptionStyles;
    sourceName: string;
}
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state)?.pathname;
    const session = state.context.session;
    return {
        location,
        session,
    };
};
export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}
export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            color: "text.main",
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
                display: -webkit-box;
                line-clamp: 2;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                font-weight: 600
            `,
        },
    },
};
const ProductDescription: FC<Props> = ({ product, location, extendedStyles, session, sourceName }) => {
    const [styles] = React.useState(() => mergeToNew(productDescriptionStyles, extendedStyles));
    const description =
        product.coveoProduct.title ? product.coveoProduct.title : product.coveoProduct.shortDescription;

    const canonicalUrl = product.coveoProduct.canonicalUrl;

    const clickHandler = () => {
        sessionStorage.setItem("item_list_name", sourceName);
        // sendClickEvent(product.coveoProduct);
        product.coveoProduct.interactiveProduct?.select();
    };

    return canonicalUrl ? (
        <Link
            {...styles.productDetailLink}
            href={canonicalUrl}
            alt={`See product details for ${description}`}
            data-test-selector="productDescriptionLink"
            onClick={clickHandler}
        >
            {description}
        </Link>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}</Typography>
    );
};

export default connect(mapStateToProps)(ProductDescription);
